import { render, staticRenderFns } from "./AddPatientDrug.vue?vue&type=template&id=154b9699&scoped=true"
import script from "./AddPatientDrug.vue?vue&type=script&lang=js"
export * from "./AddPatientDrug.vue?vue&type=script&lang=js"
import style0 from "./AddPatientDrug.vue?vue&type=style&index=0&id=154b9699&prod&scoped=true&lang=css"
import style1 from "./AddPatientDrug.vue?vue&type=style&index=1&id=154b9699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154b9699",
  null
  
)

export default component.exports